import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/toaster";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <SmoothScroll>
      <div className="App bg-slate-950 min-h-screen" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </SmoothScroll>
  );
}

export default App;
